/**
 * Constantes de Rutas del menú principal.
 */
export const VENTANILLA_ROUTE = "/app/ventanilla/";
export const EDICION_POSTURA_ROUTE = "/app/edicionPostura/";
export const LOG_ROUTE = "/app/log/";
export const VALUE_TYPES_ROUTE = "/app/valueTypes/";
export const ORDER_ADMIN_ROUTE = "/app/orderAdmin/";
export const EXTENSION_ADMIN_ROUTE = "/app/extensionAdmin/";
export const AVAILABLE_VALUES_FID_ROUTE = "/app/availableValuesFid/";
export const SETTLEMENT_ROUTE = "/app/settlement/";
export const CLOSE_ROUTE = "/app/close/";
export const LOANABLE_VALUES_ROUTE = "/app/loanableValues/";
export const CONTROL_PANEL_ROUTE = "/app/controlPanel/";
export const INVOICE_ROUTE = "/app/invoice/";
export const CAPTURE_GUARANTEES_ROUTE = "/app/captureGuarantees/";
export const CORPORATE_ACTION_ROUTE = "/app/corporateAction/";
export const EMAIL_ADMIN_ROUTE = "/app/emailAdmin/";
export const TRUST_POSITION_ROUTE = "/app/trustPosition/";
export const CAPACITY_ROUTE = "/app/capacity/";
export const USER_ROUTE = "/app/user/";
export const VALUES_REQUEST_ROUTE = "/app/valuesRequest/";
export const MAINTENANCE_ACCOUNTS_ROUTE = "/app/maintenanceAccounts/";
export const CONTRACT_OTC_ROUTE = "/app/contractOTC/";
export const OPERATION_AMOUNT_ROUTE = "/app/operationAmount/";
export const GUARANTEES_TABLES_ROUTE = "/app/guaranteesTables/";
export const CAPACITY_TABLE_ROUTE = "/app/capacityTable/";
export const MAINTENANCE_INSTITUTIONS_ROUTE = "/app/maintenanceInstitutions/";
export const MAINTENANCE_SCHEDULE_ROUTE = "/app/maintenanceSchedule/";
export const CLIENT_GSS = "/app/clientGSS/";
export const AVAILABLE_LEND = "/app/availableLend/";
export const MAINTENANCE_USERS_ROUTE = "/app/maintenanceUsers/";
export const MAINTENANCE_DOMAINS_ROUTE = "/app/maintenanceDomains/";
export const CAPTURE_LOANABLE_VALUES_ROUTE = "/app/captureLoanableValues/";
export const GUARANTEE_SELECTION_ROUTE = "/app/guaranteeSelection/";
export const CONSULT_AFORO_ROUTE = "/app/consultAforo/";
export const MAINTENANCE_AFORO_ROUTE = "/app/maintenanceAforo/";
export const MAINTENANCE_INSTRUMENT_ROUTE = "/app/maintenanceInstrument/";

export const CONTINGENCY_TRUST_ROUTE = "/app/contingencyTrust/";
export const CONTINGENCY_TRUST_BBVA_ROUTE = "/app/contingencyTrustBbva/";
export const CUSTODY_TITLES_ROUTE = "/app/custodyTitles/";

/**
 * Constantes de Rutas para Custodia
 */
export const CUSTODIA_BANAMEX = "/app/custodiaBanamex/";
export const CUSTODIA_BBVA = "/app/custodiaBBVA/";
export const CUSTODIA_TITULOS_MANT = "/app/custodiaTitulosMant/";

/**
 * Constantes de Rutas para User Routes
 */
export const CHANGE_PASSWORD_ROUTE = "/app/changePassword/";

/**
 * Constantes de Rutas para Ventanilla
 */
export const VENTANILLA_ORDER_PTM_ROUTE = "/app/ventanillaOrderPtm/";
export const VENTANILLA_ORDER_PTT_ROUTE = "/app/ventanillaOrderPtt/";
export const TODAY_TRADE_VENTANILLA_ROUTE = "/app/todayTradeVentanilla/";

/**
 * Constantes de Rutas para Mantenimiento de instituciones
 */
export const INSERT_INSTITUTION_ROUTE = "/app/insertInstitution/";
export const UPDATE_INSTITUTION_ROUTE = "/app/updateInstitution/";
export const INSERT_CONTACT_ROUTE = "/app/insertContact/";
export const INSERT_SIGN_ROUTE = "/app/insertSign/";

/**
 * Constantes de Rutas comunes
 */
export const ADD_INSTRUMENT_ROUTE = "/app/addInstrument/";

/**
 * Constantes de Rutas de operación
 */
export const INSERT_EXTENSION_ADMIN_ROUTE = "/app/insertExtensionAdmin/";
export const CONFIRM_EXTENSION_ADMIN_ROUTE = "/app/confirmExtension/";
export const INSERT_ORDER_TRADE_ADMIN_ROUTE = "/app/insertOrderTradeAdmin/";
export const UPDATE_ORDER_ADMIN_ROUTE = "/app/updateOrderAdmin/";
export const TAKE_ORDER_ADMIN_ROUTE = "/app/takeOrderAdmin/";
export const MASSIVE_AGREEMENT_ROUTE = "/app/massiveAgreement/";

/**
 * Constantes de Rutas para Contrato Bilateral otc
 */
export const EDIT_CONTRACT_ROUTE = "/app/editContract/";

/**
 * Constantes de Rutas para Mantenimiento de Cuentas y Bóvedas
 */
export const INSERT_ACCOUNT_ROUTE = "/app/insertAccount/";
export const EDIT_ACCOUNT_ROUTE = "/app/editAccount/";

/**
 * Constantes de Rutas para Prestatario
 */
export const SET_ORDER_BORROWER_ROUTE = "/app/setOrderBorrower/";
export const UPDATE_ORDER_BORROWER_ROUTE = "/app/updateOrderBorrower/";

/**
 * Constantes de Rutas para Ejercicios de Derecho
 */
export const SPLIT_ROUTE = "/app/splitCorporateAction/";
export const EXCHANGE_ROUTE = "/app/exchangeCorporateAction/";
export const PAYMENT_ROUTE = "/app/paymentCorporateAction/";
export const DETAIL_CORPORATE_ACTION_ROUTE = "/app/detailCorporateAction/";

/**
 * Constantes de Rutas para Mantenimiento de Horarios
 */
export const MODIFY_INSTITUTION_SCHEDULE_ROUTE = "/app/modifyInstitutionSchedule/";

/**
 * Constantes de Rutas para Captura de Garantías
 */
export const ADD_POSITION_ROUTE = "/app/addPosition/";
export const EDIT_POSITION_ROUTE = "/app/editPosition/";
/**
 * Control Panel
 */
export const CONTROL_PANEL_DETAIL_LOAN_ROUTE = "/app/detailLoanControlPanel/";
export const CONTROL_PANEL_TRANSACTIONAL_LOG = "/app/transactionalLogControlPanel/";
export const CONTROL_PANEL_RESTRICTION_GUARANTEE_SELECTION = "/app/restrictionGuaranteeSelectionControlPanel/";
export const CONTROL_PANEL_BREAK_LOAN = "/app/loanBreachControlPanel/";
export const CONTROL_PANEL_RETURN_MATURITY = "/app/returnMaturityControlPanel/";
export const CONTROL_PANEL_EXCESS_LOAN = "/app/excessLoanControlPanel/";
export const CONTROL_PANEL_CAPTURE_GUARANTEE = "/app/captureGuaranteeControlPanel/";
export const CONTROL_PANEL_MARGIN_CALL = "/app/marginCallControlPanel/";
export const CONTROL_PANEL_GUARANTEE_REPLACEMENT = "/app/guaranteeReplacementControlPanel/";
export const CONTROL_PANEL_MOVE_TITLE_GUARANTEE = "/app/moveTitleGuaranteeControlPanel/";
export const CONTROL_PANEL_EXTENSION_LOAN = "/app/extensionLoanControlPanel/";
export const CONTROL_PANEL_NEW_LOAN = "/app/newLoanControlPanel/";
export const CONTROL_PANEL_SETTLE_BREACH = "/app/loanSettleBreachControlPanel/";

/**
 * Constantes de Rutas para Mantenimiento de Usuarios
 */
export const UPDATE_USER_ROUTE = "/app/updateUser/";
export const USER_PERMISSIONS_ROUTE = "/app/userPermissions/";

/**
 * Constantes de Rutas para Captura de valores prestables
 */
export const ADD_POSITION_LOANABLE_ROUTE = "/app/addPositionLoanable/";
export const EDIT_POSITION_LOANABLE_ROUTE = "/app/editPositionLoanable/";

/**
 * Constantes de Rutas para Selección de garantías
 *
 */
export const EDIT_GUARANTEE_SELECTION_ROUTE = "/app/editGuaranteeSelection/";

/**
 * Constantes de Rutas para Reportes
 *
 */
export const DAILY_LOANS_REPORT_ROUTE = "/app/dailyLoansReport/";
export const ACTIVE_GUARANTEES_DETAIL_REPORT_ROUTE = "/app/activeGuaranteesDetailReport/";
export const ACTIVE_GUARANTEES_DETAIL_WITH_LOAN_IN_FLOW_REPORT_ROUTE = "/app/activeGuaranteesDetailWithLoanInFlowReport/";
export const HISTORICAL_REPORT_ROUTE = "/app/historicalReport/";
export const SEND_CONFIRMATION_REPORT_ROUTE = "/app/sendConfirmation/";
export const ACTIVE_LOANS_REPORT_ROUTE = "/app/activeLoansReport/";
export const CONCENTRATED_POSITION_REPORT_ROUTE = "/app/concentratedPosition/";
export const ACTIVE_MARKET_LOANS_REPORT_ROUTE = "/app/activeMarketLoans";
export const DONE_LOANS_REPORT_ROUTE = "/app/doneLoans";
export const ACTIVE_DAILY_LOANS_REPORT_ROUTE = "/app/activeDailyLoans";
export const EVENTS_REPORT_ROUTE = "/app/eventsReport/";
export const INTRA_INSTITUTIONAL_REPORT_ROUTE = "/app/intraInstitutionalReport/";
export const ALADDIN_REPORT_ROUTE = "/app/aladdinReport/";


/**
 * Constantes de Rutas para Facturacion
 */
export const EDIT_PARAMETERS_ROUTE = "/app/editParameters/";
export const EDIT_INSTITUTION_ROUTE = "/app/editInstitutionInvoice/";
export const UPDATE_ADDRESS_ROUTE = "/app/updateAddressInvoice/";

/**
 * Constantes de Rutas para Valores Disponibles PTM
 */
export const AVAILABLE_DETAIL_ROUTE = "/app/availableDetail/";
export const SEND_AVAILABLE_DETAIL_ROUTE = "/app/sendAvailableDetail/";
export const CONSULT_AVAILABLE_PTT_ROUTE = "/app/consultAvailablePTT/";

/**
 * Constantes de Rutas para Tipos de Valor
 */
export const CREATE_EDIT_GROUP_ROUTE = "/app/createEditGroup/";

/**
 * Constantes de Rutas para Emisoras
 */
export const EDIT_INSTRUMENT_ROUTE = "/app/editInstrument/";

/**
 * Constantes de Rutas para Bilaterales
 */
export const BILATERAL_CONTRACT_ROUTE = "/app/bilateralContract/";
export const EDIT_BILATERAL_CONTRACT_ROUTE = "/app/editBilateralContract/";
export const BILATERAL_BID_ADMIN_ROUTE = "/app/bilateralBidAdmin/";
export const ADD_BILATERAL_BID_ADMIN_ROUTE = "/app/addBilateralBidAdmin/";
export const TAKE_BILATERAL_BID_ADMIN_ROUTE = "/app/takeBilateralBidAdmin/";
export const EDIT_BILATERAL_BID_ADMIN_ROUTE = "/app/editBilateralBidAdmin/";
/**
 * Tablero de control bilateral
 * */
export const BILATERAL_CONTROL_PANEL_ROUTE = "/app/bilateralControlPanel/";
export const BILATERAL_CONTROL_PANEL_DETAIL_LOAN_ROUTE = "/app/bilateralDetailLoanControlPanel/";
export const BILATERAL_CONTROL_PANEL_CAPTURE_GUARANTEE = "/app/bilateralCaptureGuaranteeControlPanel/";
export const BILATERAL_CONTROL_PANEL_MOVE_TITLE_GUARANTEE = "/app/bilateralTransferTitleGuaranteeControlPanel/";
export const BILATERAL_CONTROL_PANEL_MARGIN_CALL = "/app/bilateralDetailMarginCallControlPanel/";
export const BILATERAL_CONTROL_PANEL_EXCESS_LOAN = "/app/bilateralDetailExcessControlPanel/";
export const BILATERAL_CONTROL_PANEL_MATURITY = "/app/bilateralMaturityControlPanel/";
export const BILATERAL_CONTROL_PANEL_HISTORY = "/app/bilateralLoanLogHistory/";


/**
 * Constantes MFA
 */
export const MFA_ROUTE = "/app/mfa/";
export const MFA_MANUAL_ROUTE = "/app/mfaManual/";